import { payPointsKeys } from "Api/Queries/PayPoints/usePayPointsQuery";
import type {
  ErrorResponse,
  InternalPayPointDto,
  UpdateInternalPayPointRequest,
} from "Infrastructure/Api/Api";
import { putPayPointsPublicID } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";
import { Resources, useResource } from "Translations/Resources";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { payPointKeys } from "Api/Queries/PayPoints/usePayPointQuery";

type Props = {
  onSuccess?: (publicID: string) => void;
  onError?: (error: ErrorResponse) => void;
};

type Parameters = {
  data: UpdateInternalPayPointRequest;
  publicID: string;
};

export const useUpdatePayPoint = ({ onSuccess, onError }: Props = {}) => {
  const queryClient = useQueryClient();
  const { t } = useResource();

  return useMutation<InternalPayPointDto, ErrorResponse, Parameters>({
    mutationFn: processResponseWithApiProblemDetails(
      ({ data, publicID }: Parameters) => putPayPointsPublicID(data, publicID),
    ),
    onSuccess: ({ name, publicID }) => {
      queryClient.invalidateQueries({
        queryKey: payPointsKeys.all,
      });
      queryClient.invalidateQueries({
        queryKey: payPointKeys.byId(publicID),
      });
      toast.success(t(Resources.Hooks.Paypoint.PaypointEdited, { name }));
      onSuccess?.(publicID);
    },
    onError: (error: ErrorResponse) => {
      toast.error(t(Resources.Hooks.Paypoint.PaypointEditError));
      onError?.(error);
    },
  });
};
